import { render, staticRenderFns } from "./AddVendorModal.vue?vue&type=template&id=823e29a6&"
import script from "./AddVendorModal.vue?vue&type=script&lang=js&"
export * from "./AddVendorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports